import React, {PureComponent} from 'react';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import {PageWrapper} from 'components/PageWrapper';
import {InputText} from '../../../blocks/inputs/InputText';

@inject('mcqThemesStore')
@observer
class McqThemeForm extends PureComponent {
  handleChange = e => {
    const {mcqThemesStore} = this.props;

    mcqThemesStore.handleChange({[e.target.name]: e.target.value});
  };

  render() {
    const {mcqThemesStore, submit} = this.props;
    const {mcq_theme, errors} = mcqThemesStore;
    const isNew = !mcq_theme.id;

    return (
      <PageWrapper>
        <form className="simple-form" onSubmit={submit}>
          <h2>{isNew ? 'Add mcq theme' : 'Edit mcq theme'}</h2>
          <InputText
            label='Add a Title'
            placeholder='Add a Title'
            fullWidth={true}
            onChange={this.handleChange}
            value={mcq_theme.title}
            name='title'
            errorText={errors ? errors.title : ''}
          />
          <div className="row">
            <button className="btn-new-main" type="submit">{isNew ? 'Create' : 'Edit'}</button>
            <Link to='/mcq-themes' className="btn-new-white margin-left-20">Cancel</Link>
          </div>
        </form>
      </PageWrapper>
    );
  }
}

export default McqThemeForm;



// WEBPACK FOOTER //
// ./src/modules/admin/mcqThemes/components/McqThemeForm.js